import { useEffect, useState } from "react";
import { FaBolt, FaBullseye, FaEye, FaHandshake, FaLightbulb, FaUsers } from "react-icons/fa";
import heroImg from "../assets/banner1.jpg";
import impactImg from "../assets/banner6.jpg";

const highlights = [
  {
    title: "Purpose Driven",
    desc: "Bringing renewable energy access to communities across Africa.",
    icon: <FaUsers />,
  },
  {
    title: "Technical Delivery",
    desc: "Hands-on engineering teams for installation, servicing and maintenance.",
    icon: <FaBolt />,
  },
  {
    title: "Affordable Solutions",
    desc: "Clean energy options structured for broad residential and institutional use.",
    icon: <FaLightbulb />,
  },
];

const valuesSpotlight = [
  { title: "Customer Satisfaction", icon: <FaHandshake /> },
  { title: "Skilled Personnel", icon: <FaUsers /> },
  { title: "Tailored Solutions", icon: <FaLightbulb /> },
];

export default function AboutUsContent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 70);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="MainBodySection py-5 fr-about-wrap">
      <div className="container">
        <div className="row g-4 g-lg-5 align-items-stretch">
          <div
            className="col-lg-7"
            style={{
              opacity: ready ? 1 : 0,
              transform: ready ? "translateY(0)" : "translateY(18px)",
              transition: "all 750ms ease",
            }}
          >
            <div className="fr-about-story h-100">
              <h2 className="font-bold text-secondary mb-1">DOUBLE F SMART ENERGIES ENTERPRISE</h2>
              <h4 className="text-primary font-semi-bold">Igniting Africa</h4>
              <p className="text-muted my-3">
                DOUBLE F SMART ENERGIES ENTERPRISE exists to bring clean and sustainable power to underserved regions,
                helping communities and enterprises access reliable energy.
              </p>
              <p className="text-muted mb-4">
                With highly motivated, skilled and experienced personnel, we provide tailored
                renewable and electrical solutions according to client interests and needs.
              </p>

              <div className="fr-about-rail">
                {highlights.map((item) => (
                  <div key={item.title} className="fr-about-rail-item">
                    <div className="fr-about-rail-icon">{item.icon}</div>
                    <div>
                      <h6 className="font-bold text-secondary mb-1">{item.title}</h6>
                      <p className="small text-muted mb-0">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className="col-lg-5"
            style={{
              opacity: ready ? 1 : 0,
              transform: ready ? "translateY(0)" : "translateY(18px)",
              transition: "all 750ms ease 80ms",
            }}
          >
            <div className="fr-about-media h-100">
              <div
                className="fr-about-photo-main"
                style={{ backgroundImage: `linear-gradient(130deg, rgba(7, 20, 38, 0.3), rgba(7, 20, 38, 0.45)), url(${heroImg})` }}
              />
              <div className="fr-about-meta">
                <p className="fr-kicker fr-kicker-light mb-2">Our Strength</p>
                <div className="fr-about-values">
                  {valuesSpotlight.map((item) => (
                    <div className="fr-about-value-item" key={item.title}>
                      <span className="fr-about-value-icon">{item.icon}</span>
                      <span>{item.title}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className="fr-about-photo-sub"
                style={{ backgroundImage: `linear-gradient(130deg, rgba(0, 76, 153, 0.2), rgba(0, 76, 153, 0.2)), url(${impactImg})` }}
              />
            </div>
          </div>
        </div>

        <div className="fr-about-vm-wrap mt-5">
          <div className="text-center mb-4">
            <h4 className="font-bold text-secondary mb-0">Our Direction</h4>
          </div>

          <div className="row g-3 justify-content-center">
            <div className="col-lg-5 col-md-6">
              <div className="fr-about-vm-card text-center">
                <div className="fr-about-vm-icon text-primary">
                  <FaEye />
                </div>
                <h5 className="font-bold mb-2 text-secondary">Vision</h5>
                <p className="mb-0 text-muted">
                  To become global, innovative and competitive in renewable energy while providing
                  total product and service solutions at affordable cost across Africa.
                </p>
              </div>
            </div>

            <div className="col-lg-5 col-md-6">
              <div className="fr-about-vm-card text-center">
                <div className="fr-about-vm-icon text-success">
                  <FaBullseye />
                </div>
                <h5 className="font-bold mb-2 text-secondary">Mission</h5>
                <p className="mb-0 text-muted">
                  Develop clean renewable projects and empower developing country populations
                  with sustainable, dependable and practical power systems.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
